import React from 'react';
import { Dots } from 'react-activity';

export default function ActivityIndicator() {
  return (
    <Dots
      size={16}
      style={{ backgroundColor: 'clear' }}
      className="activity-indicator"
    />
  );
}
